import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layouts from "./components/Layouts/Layouts";
import AddEditJobsFinder from "./pages/JobsFinder/AddEditJobsFinder";
import JobsFinderIndex from "./pages/JobsFinder/JobsFinderIndex";

function App() {
  return (
    <Router>
      <Layouts>
        <Routes>
          <Route path="/" element={<JobsFinderIndex />} />
          <Route path="/jobs/internship" element={<JobsFinderIndex />} />
          <Route path="/jobs/fulltime" element={<JobsFinderIndex />} />
          <Route path="/jobs/remote" element={<JobsFinderIndex />} />
          <Route path="/jobs" element={<AddEditJobsFinder />} />
          <Route path="/jobs/:jobsId" element={<AddEditJobsFinder />} />
        </Routes>
      </Layouts>
    </Router>
  );
}

export default App;
